import { MappingAndRulesPanelProps } from './types';

export const useMappingAndRulesPanel = (props: MappingAndRulesPanelProps) => {
  const handleHeaderClick = () => {
    props.onExpandedChange(!props.isExpanded);
  };

  return {
    handleHeaderClick,
  };
};
